import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useCallback } from 'react';

interface SnapshotVersionWarningProps {
  onRefresh: () => void;
  onDismiss: () => void;
}

export const SnapshotVersionWarning: React.FC<SnapshotVersionWarningProps> = ({
  onRefresh,
  onDismiss,
}) => {
  const handleRefresh = useCallback(() => {
    onRefresh();
  }, [onRefresh]);

  const handleDismiss = useCallback(() => {
    onDismiss();
  }, [onDismiss]);

  return (
    <Card
      className="border-orange-500 bg-orange-50"
      pt={{
        content: {
          className: 'py-0',
        },
      }}
    >
      <div className="flex flex-column gap-3">
        {/* Header with close button */}
        <div className="flex justify-content-between align-items-center">
          <div className="flex align-items-center gap-3">
            <i className="pi pi-exclamation-triangle text-orange-500 text-xl"></i>
            <h4 className="text-orange-700 mb-0 m-0">Outdated Snapshot</h4>
          </div>
          <Button
            icon="pi pi-times"
            size="small"
            text
            severity="secondary"
            onClick={handleDismiss}
            tooltip="Dismiss warning"
          />
        </div>

        {/* Content */}
        <div className="flex-1">
          <p className="text-orange-600 text-sm mb-2 m-0">
            You're viewing an older snapshot. Analysis will be run on this
            outdated data.
          </p>
        </div>

        {/* Footer with refresh button */}
        <div className="flex justify-content-end">
          <Button
            label="Refresh to Latest"
            icon="pi pi-refresh"
            size="small"
            severity="warning"
            onClick={handleRefresh}
          />
        </div>
      </div>
    </Card>
  );
};
